
import { canonical } from "@utils";
import { version } from "../package.json";

import { AD_LAYOUT_STUBS, PAGES } from "@/common/consts";

export default {
	name: "SingleCMSPage",
	async asyncData({ $axios, $config, route }) {
		let pageSlug = "";
		switch (route.name) {
			case PAGES.POPULAR_PAGES:
				pageSlug = ".seo.popular.popular-pages";
				break;
			case PAGES.TOP_SEARCHED:
				pageSlug = ".seo.popular.top-searched-word-combos";
				break;
			case PAGES.TOP_UNSCRAMBLES:
				pageSlug = ".seo.popular.top-unscrambles";
				break;
			case PAGES.FIVE_LETTER_WORD_LISTS:
				pageSlug = ".seo.popular.5-letter-word-lists";
				break;
			default:
				pageSlug = "";
		}
		if (pageSlug) {
			const pageURL = `${$config.API_SERVICE_CMS_V2}/wfa/article/${pageSlug}?v=${version}`;
			const response = await $axios.get(pageURL);
			if (response.status === 200 && response.data.status === 200) {
				return { pageData: response.data.data };
			}
			return { pageData: {} };
		}
	},
	data() {
		return {
			AD_LAYOUT_STUBS,
		};
	},
	head() {
		const m = {};

		const title = this.pageData?.metaTitle;
		if (title) {
			m.title = title;
		}

		const description = this.pageData?.metaDescription;
		if (description) {
			m.meta = [
				{
					name: "description",
					content: description,
				},
			];
		}

		m.link = [canonical(this.$route)];
		return m;
	},
	computed: {
		pageTitle() {
			return this.pageData?.title;
		},
		pageBodyCopy() {
			return this.pageData?.body;
		},
	},
	methods: {
		onBodyCopyClick(e) {
			if (
				e?.target?.tagName?.toUpperCase() === "A" &&
				e.target.hasAttribute("href") &&
				e.target.getAttribute("target") !== "_blank" &&
				(/\/\/wordfinder\.yourdictionary\.com/.test(
					e.target.getAttribute("href")
				) ||
					/^\/[^/]/.test(e.target.getAttribute("href")))
			) {
				const href = e.target
					.getAttribute("href")
					.replace(/^https?:\/\/wordfinder\.yourdictionary\.com/, "");
				e.preventDefault();
				this.$router.push(href);
			}
		},
	},
};
